import React from 'react'

interface GrayButtonProps {
  children: React.ReactNode
  onClick?: () => void
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  className?: string
  variant?: 'small' | 'medium' | 'large' | 'xlarge'
}

const GrayButton: React.FC<GrayButtonProps> = ({
  children,
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  variant = 'medium'
}) => {
  const variantStyles = {
    small: {
      container: 'px-3 py-2 gap-1.5',
      text: 'text-[13px] leading-[20px] font-[500]',
      fontStretch: 'font-stretch-100'
    },
    medium: {
      container: 'px-3 py-2 gap-1.5',
      text: 'text-sm leading-5 font-medium',
      fontStretch: ''
    },
    large: {
      container: 'px-6 py-3 gap-2',
      text: 'text-[18px] leading-[20px] font-[500]',
      fontStretch: ''
    },
    xlarge: {
      container: 'px-6 py-3 gap-2',
      text: 'text-[18px] leading-[20px]',
      fontStretch: ''
    }
  }

  const currentVariant = variantStyles[variant]

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        ${currentVariant.container}
        flex flex-row justify-center items-center
        bg-[#F5F5F5]
        shadow-[0px_1px_2px_rgba(0,0,0,0.12),0px_0px_0px_1px_rgba(0,0,0,0.08)]
        rounded-md
        ${currentVariant.text}
        ${variant === 'small' || variant === 'xlarge' ? currentVariant.fontStretch : ''}
        hover:transition-all hover:duration-200
        text-buttons-text-secondary
        hover:bg-[#E5E5E5] hover:shadow-[0px_2px_4px_rgba(0,0,0,0.16),0px_0px_0px_1px_rgba(0,0,0,0.12)]
        active:bg-[#D4D4D4] active:shadow-[0px_1px_2px_rgba(0,0,0,0.12),0px_0px_0px_1px_rgba(0,0,0,0.08)]
        disabled:bg-gray-300 disabled:text-gray-500 disabled:shadow-none disabled:cursor-not-allowed
        active:transition-all active:duration-200
        ${className}
      `}>
      {children}
    </button>
  )
}

export default GrayButton
